import React from 'react';
import { Spinner } from 'reactstrap';
import '../assets/styles/loader.css';

export const Loader = () => (
  <div
    style={{
      height: '100px',
      width: '100%',
      display: 'flex',
      position: 'sticky',
      textAlign: 'center',
    }}
  >
    <div className="loading">
      <Spinner color="primary" />
    </div>
  </div>
);
